export default {
  "pl": {
    "levels": {
      "actions": {
        "cancel": "Cofnij",
        "changeLevel": "Zmień poziom",
        "changeTargetGroup": "Zmień grupę docelową",
        "delete": "Usuń",
        "removeCustomer": "Usuń klienta",
        "requestUnits": "Poproś o dodatkowe jednostki",
        "save": "Zapisz"
      },
      "building": "Budynek",
      "customers": "Klienci",
      "labels": {
        "activity": "Aktywność",
        "allLevels": "Wszystkie poziomy",
        "decisions": "Decyzje",
        "deleteWarning": "Uwaga! Usunięcie tego poziomu spowoduje usunięcie wszystkich związanych z nim poziomów, dokumentów, ogłoszeń, FAQ i zadań.",
        "documents": "Dokumenty",
        "hide": "Ukryj",
        "information": "Informacje",
        "installment": "Dane finansowe",
        "milestones": "Kamienie milowe",
        "multiple_selection": "Wielokrotny wybór",
        "needMoreUnits": "Potrzebujesz więcej jednostek?",
        "reachedMax": "Utworzono jednostkę przypisaną do tego projektu. | Osiągnięto następującą liczbę jednostek w tym projekcie: {count}.",
        "reachedMaxRundle": "Osiągnąłeś limit 1 jednostki. | Osiągnąłeś limit {count} jednostek.",
        "requestMoreUnits": "Jeśli chcesz zwiększyć tę liczbę, skontaktuj się z zespołem Ziggu.",
        "sharedWith": "Udostępniono: ",
        "showForLevel": "Pokaż element {object} dla danego poziomu",
        "spaces": "Przestrzenie",
        "surveys": "Ankiety",
        "tickets": "Rozmowy",
        "todos": "Zadania",
        "willBeAssigned": "Zawartość dostępna dla każdego w:",
        "willBePublished": "Zawartość zostanie udostępniona każdemu w:",
        "willBeUploaded": "Zawartość zostanie przesłana do:"
      },
      "lot": "Działka",
      "phase": "Faza",
      "project": "Projekt",
      "unit": "Jednostka"
    }
  }
}
